import { Box, Typography } from '@mui/material';
import { OutlinedSearchField } from 'Components/OutlinedSearchField';
import { SEARCH_FIELD_ICON_SIZE } from 'Components/SearchFieldIcon';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ChangeEvent, RefObject } from 'react';

interface SearchInputProps {
  value: string;
  inputRef: RefObject<HTMLInputElement | null>;
  useCurtain: boolean;
  source?: string;
  onInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  onClear: () => void;
}

export const SearchInput = ({
  value,
  inputRef,
  useCurtain,
  source,
  onInputChange,
  onKeyDown,
  onClear,
}: SearchInputProps) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.ActivitiesLobby);
  const isDesktop = useIsDesktop();
  const clearLabel = Dictionary[DICTIONARY.General].clearSearch;
  const isHeaderSearch = source === 'header';

  return (
    <Box
      sx={{
        position: 'relative',
        width: isDesktop ? '564px' : '100%',
      }}
    >
      {value.length === 0 && useCurtain && (
        <Typography
          component='span'
          variant='body3'
          sx={{
            position: 'absolute',
            top: '50%',
            right: `calc(16px + ${SEARCH_FIELD_ICON_SIZE}px + 8px)`,
            transform: 'translateY(-50%)',
            pr: isHeaderSearch ? 0 : 2,
            color: 'text.secondary',
            pointerEvents: 'none',
            zIndex: 1,
          }}
        >
          {dictionary.searchInfoOrActions}
        </Typography>
      )}
      <OutlinedSearchField
        value={value}
        onChange={(nextValue) =>
          onInputChange({
            target: { value: nextValue },
          } as ChangeEvent<HTMLInputElement>)
        }
        onClear={onClear}
        clearAriaLabel={clearLabel}
        ariaLabel={dictionary.searchInfoOrActions}
        height='56px'
        borderRadius='30px'
        searchIconMode='decorative'
        inputRef={inputRef}
        onKeyDown={onKeyDown}
        wrapperSx={{ width: '100%' }}
      />
    </Box>
  );
};
